
/* THE NINETY V11 — self-contained real-media editorial preloader & page brand screen */
(()=>{'use strict';
 const root=document.documentElement;
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const config=document.getElementById('ninety-v11-config');
 if(!config)return;
 const enabled=()=>document.body.dataset.motionEnabled!=='false'&&!window.Shopify?.designMode&&!reduce.matches;
 const images=String(config.dataset.photos||'').split('|').filter(Boolean);
 const create=(tag,className,parent)=>{const n=document.createElement(tag);n.className=className;parent?.append(n);return n};
 let route=null,timeoutId=null,shownIntro=false;
 function enter(){
   if(!enabled()||!route)return Promise.resolve();
   clearTimeout(timeoutId);
   route.classList.remove('is-exiting');
   route.classList.add('is-active');
   return new Promise(resolve=>setTimeout(resolve,460));
 }
 function exit(){
   if(!route)return;
   route.classList.remove('is-active');route.classList.add('is-exiting');
   clearTimeout(timeoutId);timeoutId=setTimeout(()=>{route.classList.remove('is-exiting')},550);
 }
 function initRoute(){
   route=create('div','n11-route',document.body);route.id='n11-route';route.setAttribute('aria-hidden','true');
   const word=create('div','n11-word',route);word.dir='ltr';word.textContent='THE NINETY';

 }
 function initIntro(){
   if(!enabled()||document.body.dataset.motionIntro==='false'||!document.body.classList.contains('ninety-template-index'))return;
   if(sessionStorage.getItem('ninety-v11-seen')==='yes')return;
   let finished=false;
   shownIntro=true;
   root.classList.add('n11-intro-active');
   const overlay=create('div','n11-intro',document.body);overlay.setAttribute('role','dialog');overlay.setAttribute('aria-label','THE NINETY — مقدمة الموقع');
   overlay.setAttribute('aria-modal','true');
   const inner=create('div','n11-inner',overlay);
   const word=create('div','n11-word',inner);word.dir='ltr';word.textContent='THE NINETY';
   const number=create('span','n11-no',inner);number.textContent='000';
   const stack=create('div','n11-collage',inner);
   const photos=images.slice(0,5);
   photos.forEach((src,i)=>{const img=create('img','n11-photo',stack);img.src=src;img.alt='';img.decoding='async';img.setAttribute('aria-hidden','true');img.style.cssText='--x:'+([-17,13,-10,19,0][i])+'px;--y:'+([-8,-8,8,8,0][i])+'px;--r:'+([-14,12,-8,9,0][i])+'deg;--delay:'+(160+i*165)+'ms;z-index:'+(i+1)});
   const meta=create('div','n11-progress',overlay);meta.innerHTML='<span>THE NINETY® / RIYADH</span><strong id="n11-counter">000</strong><span>001 / THE EDIT</span>';
   const track=create('div','n11-track',overlay);
   const start=performance.now(),duration=2050;
   const finish=()=>{if(finished)return;finished=true;try{sessionStorage.setItem('ninety-v11-seen','yes')}catch{}
     overlay.classList.add('is-leaving');root.classList.remove('n11-intro-active');root.classList.remove('n10-intro');
     document.dispatchEvent(new CustomEvent('ninety:intro:complete'));
     setTimeout(()=>overlay.remove(),440);
   };
   const advance=now=>{
     if(finished||!overlay.isConnected)return;
     const p=Math.min(1,(now-start)/duration);
     number.textContent=String(Math.floor(p*100)).padStart(3,'0');
     meta.querySelector('#n11-counter').textContent=String(Math.floor(p*100)).padStart(3,'0')+' / 100';
     track.style.width=(p*100)+'%';
     if(p>=1){finish();return}
     requestAnimationFrame(advance);
   };
   let sequence=0;const shuffle=()=>{const pics=[...stack.children];const pic=pics[sequence%pics.length];sequence++;if(!pic||finished)return;pic.classList.remove('n11-shuffle');void pic.offsetWidth;pic.classList.add('n11-shuffle')};
   const interval=setInterval(()=>{if(finished){clearInterval(interval);return}shuffle()},420);
   requestAnimationFrame(advance);
   setTimeout(finish,2200);
 }
 window.NinetyV11={enter,exit};
 const init=()=>{initRoute();initIntro();if(!shownIntro&&route){try{const ref=new URL(document.referrer);if(ref.origin===location.origin&&performance.getEntriesByType('navigation')[0]?.type==='navigate'){route.classList.add('is-active');requestAnimationFrame(()=>requestAnimationFrame(exit))}}catch{}}};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 addEventListener('pageshow',e=>{if(e.persisted)exit()});
 reduce.addEventListener?.('change',()=>{if(reduce.matches){document.querySelector('.n11-intro')?.remove();root.classList.remove('n11-intro-active');exit()}});
})();
